"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCKET_INCOMING_COMMAND = void 0;
exports.SOCKET_INCOMING_COMMAND = '@sok/notifications/SOCKET_INCOMING_COMMAND';
//# sourceMappingURL=socket.js.map